/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
} from './APIMeta';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
} from './APIResponseError';
import type { AccessRequestDetail } from './AccessRequestDetail';
import {
    AccessRequestDetailFromJSON,
    AccessRequestDetailFromJSONTyped,
    AccessRequestDetailToJSON,
} from './AccessRequestDetail';

/**
 * 
 * @export
 * @interface GetAccessRequestsMe200Response
 */
export interface GetAccessRequestsMe200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetAccessRequestsMe200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetAccessRequestsMe200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {Array<AccessRequestDetail>}
     * @memberof GetAccessRequestsMe200Response
     */
    result: Array<AccessRequestDetail>;
}

/**
 * Check if a given object implements the GetAccessRequestsMe200Response interface.
 */
export function instanceOfGetAccessRequestsMe200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function GetAccessRequestsMe200ResponseFromJSON(json: any): GetAccessRequestsMe200Response {
    return GetAccessRequestsMe200ResponseFromJSONTyped(json, false);
}

export function GetAccessRequestsMe200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAccessRequestsMe200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': !exists(json, 'meta') ? undefined : APIMetaFromJSON(json['meta']),
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': ((json['result'] as Array<any>).map(AccessRequestDetailFromJSON)),
    };
}

export function GetAccessRequestsMe200ResponseToJSON(value?: GetAccessRequestsMe200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': APIMetaToJSON(value.meta),
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(APIResponseErrorToJSON)),
        'result': ((value.result as Array<any>).map(AccessRequestDetailToJSON)),
    };
}

